import { useParams } from 'react-router-dom';
import { Tile } from 'components/Layout/PageContainer';
import { MetricsLoadingSpinner } from 'components/MetricsLoadingSpinner';
import { useEffect } from 'react';
import { useBreadcrumbStore } from 'hooks/state/useBreadcrumbStore';
import { BreadcrumbItem } from 'components/breadcrumb/breadcrumbModel';
import { useStyleSummary } from 'pages/entities/queryHooks';
import { getErrorMessage } from 'utils/getErrorMessage';
import { EntityPage } from 'pages/entities/components/EntityPage';
import { Filters } from 'services/data.service';
import { useModelService } from 'services/model/model.service';
import { StyleDetailsSummary } from 'pages/entities/style/StyleDetailsSummary';
import { createStyleNameFromAttributes, decodeStyle } from 'pages/entities/entityhelper';

export function StyleEntityPage() {
  const { style: encodedStyle } = useParams();
  const { getAttributes } = useModelService();

  const { productNumber, style } = decodeStyle(encodedStyle ?? '');

  const { data: summaryResponse, error: summaryError } = useStyleSummary(productNumber, style);

  // replace the product number in breadcrumb by the product name when data is loaded
  useEffect(() => {
    if (productNumber) {
      const { breadcrumbs, setBreadcrumbs } = useBreadcrumbStore.getState();

      const updateProductBreadcrumb = (items: BreadcrumbItem[]): BreadcrumbItem[] =>
        items.map(item => {
          if (item.path?.includes(productNumber)) {
            return {
              ...item,
              label: createStyleNameFromAttributes(summaryResponse?.attributes ?? {}),
            };
          }

          return item;
        });

      const updatedBreadcrumbs = updateProductBreadcrumb(breadcrumbs);
      setBreadcrumbs(updatedBreadcrumbs);
    }
  }, [summaryResponse, productNumber]);

  if (!summaryResponse && !summaryError) {
    return <MetricsLoadingSpinner />;
  }

  const filterDecorator = (filters: Filters) => {
    return { ...filters, productNumbers: [productNumber], colours: [style] };
  };

  const availableTables = getAttributes(['chnMarketplace', 'chnCountry', 'artEan']);

  return (
    <EntityPage filterDecorator={filterDecorator} availableTables={availableTables}>
      {summaryError ? (
        <Tile title={productNumber} errorDetails={getErrorMessage(summaryError)} />
      ) : (
        <StyleDetailsSummary response={summaryResponse} />
      )}
    </EntityPage>
  );
}
